import { Link } from 'react-router-dom';
import { ModeToggle } from '@/components/mode-toggle';
import { Logo } from '@/components/Logo';

export default function BetaServicesAddendumPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border/60">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
          <Link to="/" className="inline-flex items-center gap-2 hover:opacity-80 transition-opacity">
            <Logo size={26} withText textClassName="font-kronaone tracking-wide" />
          </Link>
          <ModeToggle />
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-12 space-y-10">
        <div className="space-y-3">
          <h1 className="text-3xl font-semibold tracking-tight">Scrambl Beta Services Addendum</h1>
          <p className="text-sm text-muted-foreground">Effective Date: January 01, 2026</p>
          <p className="text-base text-muted-foreground">
            This Beta Services Addendum (&quot;Addendum&quot;) applies to beta, preview, experimental, or
            early access features of the Service (&quot;Beta Services&quot;). This Addendum is part of and
            incorporated into the Scrambl Terms of Service.
          </p>
        </div>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold">1. Scope and Availability</h2>
          <p className="text-sm text-muted-foreground">
            Beta Services are provided for evaluation and feedback. They may be incomplete, unstable, or
            subject to change, and may be modified, paused, or discontinued at any time without notice.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold">2. No SLA or Support Commitments</h2>
          <p className="text-sm text-muted-foreground">
            We do not provide any service level commitments for Beta Services. Support, response times,
            or feature availability may be limited or unavailable.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold">3. Data Loss and Backup Disclaimer</h2>
          <p className="text-sm text-muted-foreground">
            Beta Services may involve increased risk of errors, downtime, and data loss. We make reasonable
            efforts to protect and back up data and generally perform nightly backups, but restoration is
            not guaranteed. You are responsible for maintaining your own backups and copies of important
            data.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold">4. Use at Your Own Risk</h2>
          <p className="text-sm text-muted-foreground">
            You should not rely on Beta Services for mission-critical or high-risk activities. Beta Services
            are provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold">5. Feedback</h2>
          <p className="text-sm text-muted-foreground">
            If you provide feedback, suggestions, or ideas about Beta Services, you grant Scrambl a
            perpetual, worldwide, royalty-free license to use that feedback without restriction or
            compensation.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold">6. Termination</h2>
          <p className="text-sm text-muted-foreground">
            We may terminate or restrict access to Beta Services at any time. If Beta Services are
            discontinued, we are not obligated to migrate or preserve any data created solely through those
            features.
          </p>
        </section>
      </main>

      <footer className="border-t border-border/60">
        <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-muted-foreground sm:flex-row">
          <span>&copy; {new Date().getFullYear()} Scrambl. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <a
              href="https://scrambl.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Terms of Service
            </a>
            <a
              href="https://scrambl.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
